import summarizeStyle from "./summarize.module.css";
import React, { useState } from "react";
import { StyledEngineProvider } from "@mui/material/styles";
import InteractionsByDays from "../../components/tables/InteractionsByDays";
import ActionBtn from "../../components/UI/actionbtn";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import SearchIcon from "@mui/icons-material/Search";
import api from "../../services/api";
import { toast } from "react-toastify";
import CircularLoading from "../../components/loadModules/circularLoading.js";

export default function SmsList() {
  const defaultWabaSearch = {
    data_start: "",
    data_end: "",
  };

  const [wabaSearch, setWabaSearch] = useState({ ...defaultWabaSearch });
  const [retornoAPI, setRetornoAPI] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleChange = (type, value) => {
    setWabaSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const loadTables = async () => {
    if (wabaSearch.data_start === "" || wabaSearch.data_end === "") {
      toast.warning("Preencha as datas de início e fim para a busca");
      return;
    }

    const startDate = new Date(wabaSearch.data_start);
    const endDate = new Date(wabaSearch.data_end);

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      toast.warning("Datas inválidas. Verifique os campos de início e fim.");
      return;
    }

    if (endDate < startDate) {
      toast.warning("A data final deve ser maior ou igual à data inicial.");
      return;
    }

    // Diferença em dias
    const diffMs = endDate.getTime() - startDate.getTime();
    const diffDays = diffMs / (1000 * 60 * 60 * 24);

    if (diffDays > 31) {
      toast.warning("O intervalo máximo de busca é de 31 dias.");
      return;
    }

    setLoading(true);

    try {
      const start = startDate.toISOString();
      const end = endDate.toISOString();

      const res = await api.get(
        `/api/database/report/interacoes_dia?date_start=${start}&date_end=${end}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!res.data || res.data.length === 0) {
        toast.error("Erro #004: Sem resultado de busca");
        setRetornoAPI([]);
        return;
      }

      setRetornoAPI(res.data);
      toast.success("Dados carregados com sucesso");
    } catch (error) {
      console.error("Erro ao carregar dados:", error);
      toast.error("Erro ao carregar dados");
      setRetornoAPI([]);
    } finally {
      setLoading(false);
    }
  };

  const cleanSearch = () => {
    setWabaSearch({ ...defaultWabaSearch });
    setRetornoAPI([]);
  };

  return (
    <div className={summarizeStyle.summarize}>
      <div className="d-flex align-items-center justify-content-between pe-4">
        <p className="titlePage">Interações por dia</p>
        <div className="d-flex align-items-center">
          <div
            className={`d-flex align-items-center me-5 ${summarizeStyle.containerTimerHeader}`}
          >
            <label className="defaultLabel me-2">Inicio: </label>
            <input
              className="input-bootstrap"
              type="datetime-local"
              id="searchdatefrom"
              value={wabaSearch.data_start}
              onChange={(e) => handleChange("data_start", e.target.value)}
            />
          </div>

          <div
            className={`d-flex align-items-center me-3 ${summarizeStyle.containerTimerHeader}`}
          >
            <label className="defaultLabel me-2">Até: </label>
            <input
              className="input-bootstrap"
              type="datetime-local"
              id="searchdateto"
              value={wabaSearch.data_end}
              onChange={(e) => handleChange("data_end", e.target.value)}
            />
          </div>

          {/* Limpar busca */}
          <div
            onClick={() => {
              if (!loading) cleanSearch();
            }}
            style={{
              pointerEvents: loading ? "none" : "auto",
            }}
          >
            <ActionBtn
              color="yellow"
              icon={<SearchOffIcon />}
              disabled={loading}
            />
          </div>

          {/* Buscar */}
          <div
            onClick={() => {
              if (!loading) loadTables();
            }}
            style={{
              pointerEvents: loading ? "none" : "auto",
            }}
          >
            <ActionBtn color="green" icon={<SearchIcon />} disabled={loading} />
          </div>
        </div>
      </div>

      <div className={summarizeStyle.sumBottomBox}>
        {loading ? (
          <CircularLoading />
        ) : (
          <StyledEngineProvider injectFirst>
            <InteractionsByDays data={retornoAPI} />
          </StyledEngineProvider>
        )}
      </div>
    </div>
  );
}
